module.exports = __webpack_public_path__ + "static/media/scan-surface.0f8a8586.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ar/scan-surface.svg
// module id = 428
// module chunks = 0